import React from 'react';

type ServiceSummary = {
  imageSrc: string;
  title: string;
  summary: string;
  id: string;
};

const SERVICE_SUMMARIES: readonly ServiceSummary[] = [
  {
    imageSrc: `${process.env.PUBLIC_URL || ''}/images/servicesimages/${encodeURIComponent('Industrial Automation & Control Engineering.jpg')}`,
    title: 'Industrial Automation & Control Engineering',
    summary:
      'PLC & SCADA systems that automate operations, improve accuracy, and reduce downtime.',
    id: 'automation',
  },
  {
    imageSrc: `${process.env.PUBLIC_URL || ''}/images/servicesimages/${encodeURIComponent('Green Energy Solutions (Solar PV).jpg')}`,
    title: 'Green Energy Solutions (Solar PV)',
    summary:
      'Engineered solar systems for reliable power—designed for performance, safety, and ROI.',
    id: 'green-energy',
  },
  {
    imageSrc: `${process.env.PUBLIC_URL || ''}/images/servicesimages/${encodeURIComponent('Fabrication, Refractory & Mechanical.jpg')}`,
    title: 'Fabrication, Refractory & Mechanical',
    summary:
      'Fabrication and mechanical services that keep plants strong, aligned, and reliable.',
    id: 'fabrication',
  },
  {
    imageSrc: `${process.env.PUBLIC_URL || ''}/images/servicesimages/${encodeURIComponent('Technical Services, ICT & Security.jpg')}`,
    title: 'Technical Services, ICT & Security',
    summary:
      'Security, ICT, and electrical support to protect assets and keep facilities connected.',
    id: 'technical',
  },
  {
    imageSrc: `${process.env.PUBLIC_URL || ''}/images/servicesimages/${encodeURIComponent('Electrical Installation & Maintenance.jpg')}`,
    title: 'Electrical Installation & Maintenance',
    summary:
      'Engineered electrical systems that prioritise safety, reliability, and long-term performance across all sectors.',
    id: 'electrical',
  },
  {
    imageSrc: `${process.env.PUBLIC_URL || ''}/images/servicesimages/${encodeURIComponent('maintainence, refrigeration and safety equipment and hardware..jpg')}`,
    title: 'Maintenance, Refrigeration & Safety Equipment',
    summary:
      'Structured maintenance solutions, engineered refrigeration systems, and certified safety equipment to ensure operational continuity and compliance.',
    id: 'maintenance-refrigeration-safety',
  },
];

type ServicesSummaryProps = {
  onServiceClick: (serviceId: string) => void;
};

export default function ServicesSummary({ onServiceClick }: ServicesSummaryProps): React.ReactElement {
  return (
    <section className="bg-slate-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="mx-auto max-w-5xl text-center mb-12">
          <h2 className="text-3xl font-semibold leading-tight text-slate-900 sm:text-4xl">
            Our Services
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
            Comprehensive multi-discipline engineering solutions for your industrial needs
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICE_SUMMARIES.map((service) => (
            <div
              key={service.title}
              className="overflow-hidden rounded-2xl bg-white text-left ring-1 ring-slate-200 transition-shadow hover:shadow-lg flex flex-col"
            >
              <div className="aspect-[4/3] w-full bg-slate-100">
                <img
                  src={service.imageSrc}
                  alt={service.title}
                  className="h-full w-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    console.error('Failed to load service image:', service.imageSrc);
                  }}
                  onLoad={() => {
                    console.log('Service summary image loaded:', service.title);
                  }}
                />
              </div>

              <div className="p-6 flex flex-col h-full">
                <h3 className="text-lg font-semibold text-slate-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-sm leading-relaxed text-slate-600 mb-4 flex-grow">
                  {service.summary}
                </p>
                <button
                  onClick={() => onServiceClick(service.id)}
                  className="block w-full text-center rounded-md bg-sky-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-sky-700"
                >
                  See More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


